/* ── Boss Bidet Revolution V2 Landing Page JS ──
   Based on bb-revolution.js with these changes:
   - Countdown timer code removed (unused on the page)
   - Shared addToCart() used by both the hero CTA and the sticky mobile bar
   - Sticky mobile buy bar shows once the hero CTA scrolls out of view
   - Variant hero images preloaded after page load for instant switching
*/

(function () {
  'use strict';

  /* ── VARIANT SWITCHER ── */
  function initVariants() {
    var btns = document.querySelectorAll('.bb-variant-btn');
    var heroImg = document.getElementById('bb-hero-img');
    var nameDisplay = document.getElementById('bb-variant-name');
    if (!btns.length) return;

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var src = btn.getAttribute('data-img');
        var name = btn.getAttribute('data-name');
        if (heroImg && src) {
          heroImg.removeAttribute('srcset');
          heroImg.src = src;
        }
        if (nameDisplay && name) nameDisplay.textContent = name;
      });
    });

    /* Preload variant images after load so switching is instant */
    window.addEventListener('load', function () {
      btns.forEach(function (btn) {
        var src = btn.getAttribute('data-img');
        if (src) { var im = new Image(); im.src = src; }
      });
    });
  }

  /* ── QUANTITY SELECTOR ── */
  function initQty() {
    var input = document.getElementById('bb-qty-input');
    var dec   = document.getElementById('bb-qty-dec');
    var inc   = document.getElementById('bb-qty-inc');
    if (!input || !dec || !inc) return;

    dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      if (v > 1) input.value = v - 1;
    });

    inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });

    function clamp() {
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) input.value = 1;
    }
    input.addEventListener('change', clamp);
    input.addEventListener('blur', clamp);
  }

  /* ── ADD TO CART (hero CTA adds directly by default; sticky bar + CTAs open the finish sheet) ── */
  function initAddToCart() {
    var btn = document.getElementById('bb-add-btn');
    var stickyBtn = document.getElementById('bb-sticky-add');
    if (!btn) return;

    var checkoutUrl = btn.getAttribute('data-checkout-url') || '/checkout';

    function addToCart(sourceBtn) {
      var selectedBtn = document.querySelector('.bb-variant-btn.active');
      var variantId   = selectedBtn ? selectedBtn.getAttribute('data-variant-id') : null;
      var qty         = parseInt((document.getElementById('bb-qty-input') || {}).value, 10) || 1;

      if (!variantId) {
        window.location.href = checkoutUrl;
        return;
      }

      sourceBtn.disabled    = true;
      sourceBtn.textContent = 'Adding to cart…';

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body:    JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
      })
      .then(function (res) {
        if (!res.ok) { throw new Error('cart/add failed'); }
        return res.json();
      })
      .then(function () {
        window.location.href = checkoutUrl;
      })
      .catch(function () {
        window.location.href = checkoutUrl;
      });
    }

    /* Hero Add to Cart: adds directly by default, or opens the sheet when
       the merchant enables data-open-sheet (setting: hero_add_opens_sheet). */
    btn.addEventListener('click', function () {
      if (sheet && btn.getAttribute('data-open-sheet') === 'true') { openSheet(); }
      else { addToCart(btn); }
    });

    /* ── FINISH + QUANTITY SHEET (sticky bar + mid-page CTAs, mobile + desktop) ── */
    var sheet    = document.getElementById('bb-rev2-sheet');
    var sheetAdd = document.getElementById('bb-sheet-add');
    var sheetQty = document.getElementById('bb-sheet-qty-input');
    var mainQty  = document.getElementById('bb-qty-input');

    function openSheet() {
      /* Mirror current selection from the main buy box into the sheet */
      var activeMain = document.querySelector('.bb-variant-btn.active');
      var activeId = activeMain ? activeMain.getAttribute('data-variant-id') : null;
      sheet.querySelectorAll('.bb-rev2-sheet-variant').forEach(function (b) {
        b.classList.toggle('active', b.getAttribute('data-variant-id') === activeId);
      });
      if (sheetQty && mainQty) sheetQty.value = mainQty.value || 1;
      sheet.hidden = false;
      document.body.classList.add('bb-rev2-modal-open');
    }

    function closeSheet() {
      sheet.hidden = true;
      document.body.classList.remove('bb-rev2-modal-open');
    }

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (sheet) { openSheet(); } else { addToCart(stickyBtn); }
      });
    }

    /* Any CTA marked .bb-rev2-open-sheet opens the finish + quantity sheet.
       Falls back to its href (#bb-hero) if the sheet isn't present. */
    document.querySelectorAll('.bb-rev2-open-sheet').forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (sheet) { e.preventDefault(); openSheet(); }
      });
    });

    if (sheet) {
      sheet.querySelectorAll('[data-sheet-close]').forEach(function (el) {
        el.addEventListener('click', closeSheet);
      });

      /* Picking a finish in the sheet drives the main picker (one source of truth) */
      sheet.querySelectorAll('.bb-rev2-sheet-variant').forEach(function (b) {
        b.addEventListener('click', function () {
          sheet.querySelectorAll('.bb-rev2-sheet-variant').forEach(function (x) { x.classList.remove('active'); });
          b.classList.add('active');
          var main = document.querySelector('.bb-variant-btn[data-variant-id="' + b.getAttribute('data-variant-id') + '"]');
          if (main) main.click();
        });
      });

      var sheetDec = document.getElementById('bb-sheet-qty-dec');
      var sheetInc = document.getElementById('bb-sheet-qty-inc');
      if (sheetDec && sheetQty) sheetDec.addEventListener('click', function () {
        var v = parseInt(sheetQty.value, 10) || 1;
        if (v > 1) sheetQty.value = v - 1;
      });
      if (sheetInc && sheetQty) sheetInc.addEventListener('click', function () {
        var v = parseInt(sheetQty.value, 10) || 1;
        sheetQty.value = v + 1;
      });

      if (sheetAdd) {
        sheetAdd.addEventListener('click', function () {
          if (sheetQty && mainQty) {
            var v = parseInt(sheetQty.value, 10);
            mainQty.value = (isNaN(v) || v < 1) ? 1 : v;
          }
          addToCart(sheetAdd);
        });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !sheet.hidden) closeSheet();
      });
    }
  }

  /* ── STICKY BUY BAR (mobile + desktop) ──
     Shows once the hero Add to Cart scrolls out of view, and hides again once
     the final CTA / deal section is on screen so it never covers the footer. */
  function initStickyBar() {
    var bar = document.getElementById('bb-rev2-sticky');
    var heroBtn = document.getElementById('bb-add-btn');
    if (!bar || !heroBtn || !('IntersectionObserver' in window)) return;

    var deal = document.querySelector('.bb-deal');
    var pastHero = false;
    var atFinalCta = false;

    function apply() {
      var show = pastHero && !atFinalCta;
      bar.classList.toggle('bb-rev2-sticky-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        pastHero = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        apply();
      });
    }, { threshold: 0 }).observe(heroBtn);

    if (deal) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { atFinalCta = entry.isIntersecting; apply(); });
      }, { threshold: 0 }).observe(deal);
    }
  }

  /* ── VIDEO — click-to-load YouTube facade ── */
  function initVideo() {
    var wrap = document.getElementById('bb-video-wrap');
    var btn  = document.getElementById('bb-watch-btn');
    if (!wrap) return;

    var raw     = wrap.getAttribute('data-video-url') || 'https://www.youtube.com/watch?v=OGryPh0-Ktw';
    var videoId = '';
    var m = raw.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_-]{11})/);
    if (m) { videoId = m[1]; }
    else if (/^[A-Za-z0-9_-]{11}$/.test(raw.trim())) { videoId = raw.trim(); }

    if (!videoId) videoId = 'OGryPh0-Ktw';

    function embedVideo() {
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + videoId +
                   '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      iframe.title          = 'Boss Bidet Revolution';
      iframe.frameBorder    = '0';
      iframe.allow          = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.style.cssText  = 'width:100%;aspect-ratio:16/9;display:block;border:none;border-radius:10px;';
      wrap.style.aspectRatio = '16/9';
      wrap.style.cursor      = 'default';
      wrap.innerHTML = '';
      wrap.appendChild(iframe);
      wrap.removeEventListener('click', embedVideo);
      if (btn) btn.removeEventListener('click', embedVideo);
    }

    wrap.addEventListener('click', embedVideo);
    if (btn) btn.addEventListener('click', embedVideo);
  }

  /* ── FAQ ACCORDION ── */
  function initFaq() {
    var questions = document.querySelectorAll('.bb-faq-q');
    questions.forEach(function (q) {
      q.addEventListener('click', function () {
        var answer = q.nextElementSibling;
        var icon   = q.querySelector('.bb-faq-icon');
        var isOpen = answer.style.display === 'block';

        document.querySelectorAll('.bb-faq-a').forEach(function (a) { a.style.display = 'none'; });
        document.querySelectorAll('.bb-faq-q').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        document.querySelectorAll('.bb-faq-icon').forEach(function (i) {
          i.textContent  = '+';
          i.style.transform = 'rotate(0deg)';
        });

        if (!isOpen) {
          answer.style.display = 'block';
          q.setAttribute('aria-expanded', 'true');
          if (icon) { icon.textContent = '+'; icon.style.transform = 'rotate(45deg)'; }
        }
      });
    });
  }

  /* ── VARIANT NAME TWO-LINE SPLIT ── */
  function initVariantNameSplit() {
    document.querySelectorAll('.bb-variant-btn span').forEach(function (el) {
      var parts = el.textContent.trim().split(' ');
      if (parts.length >= 2) {
        el.innerHTML = parts[0] + '<br>' + parts.slice(1).join(' ');
      }
    });
  }

  /* ── REVIEWS CAROUSEL ── */
  function initReviewsCarousel() {
    var track   = document.getElementById('bb-reviews-track');
    var prevBtn = document.getElementById('bb-rev-prev');
    var nextBtn = document.getElementById('bb-rev-next');
    if (!track || !prevBtn || !nextBtn) return;

    var cards   = track.querySelectorAll('.bb-review-card');
    var total   = cards.length;
    var current = 0;

    function perView() {
      return window.innerWidth <= 768 ? 1 : 3;
    }

    function getCardWidth() {
      if (!cards[0]) return 0;
      return cards[0].getBoundingClientRect().width + 20;
    }

    function maxIndex() {
      return Math.max(0, total - perView());
    }

    function update() {
      var offset = current * getCardWidth();
      track.style.transform = 'translateX(-' + offset + 'px)';
      prevBtn.disabled = current === 0;
      nextBtn.disabled = current >= maxIndex();
    }

    prevBtn.addEventListener('click', function () {
      if (current > 0) { current--; update(); }
    });

    nextBtn.addEventListener('click', function () {
      if (current < maxIndex()) { current++; update(); }
    });

    var touchStartX = 0;
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (dx < -40 && current < maxIndex()) { current++; update(); }
      if (dx >  40 && current > 0)          { current--; update(); }
    }, { passive: true });

    window.addEventListener('resize', function () {
      current = Math.min(current, maxIndex());
      update();
    });

    update();
  }

  /* ── REVIEWS MODAL — shows the product page's Judge.me reviews in-page ── */
  function initReviewsModal() {
    var openLink = document.getElementById('bb-reviews-open');
    var modal    = document.getElementById('bb-reviews-modal');
    var target   = document.getElementById('bb-rev2-reviews-target');
    if (!openLink || !modal) return;

    /* Fetch the product page (same origin) and lift out its server-rendered
       Judge.me review widget — reviews, ratings histogram, pagination. */
    function loadReviews() {
      if (!target || target.getAttribute('data-loaded')) return;
      target.setAttribute('data-loaded', 'pending');

      fetch(target.getAttribute('data-source-url') || '/products/bossbidet-revolution')
        .then(function (res) {
          if (!res.ok) { throw new Error('fetch failed'); }
          return res.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var widget = doc.getElementById('judgeme_product_reviews') ||
                       doc.querySelector('.jdgm-review-widget');
          if (!widget) { throw new Error('widget not found'); }
          target.innerHTML = '';
          target.appendChild(widget);
          target.setAttribute('data-loaded', 'true');
        })
        .catch(function () {
          target.removeAttribute('data-loaded');
          target.innerHTML = '<p class="bb-rev2-modal-loading">Reviews could not be loaded right now — use the link below to read them.</p>';
        });
    }

    function openModal(e) {
      e.preventDefault();
      modal.hidden = false;
      document.body.classList.add('bb-rev2-modal-open');
      loadReviews();
    }

    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove('bb-rev2-modal-open');
    }

    openLink.addEventListener('click', openModal);
    modal.querySelectorAll('[data-modal-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  /* ── INIT ── */
  document.addEventListener('DOMContentLoaded', function () {
    initVariants();
    initQty();
    initAddToCart();
    initStickyBar();
    initVideo();
    initFaq();
    initVariantNameSplit();
    initReviewsCarousel();
    initReviewsModal();
  });

})();
